<template>
  <component :is="tag" :class="classObject" :to="to">
    <slot />
  </component>
</template>

<script setup>
import { FAMILIES } from "@/constants/typography";
import { computed, defineProps } from "vue";

const { type, colored, as, to } = defineProps(["type", "colored", "as", "to"]);

const classObject = computed(() => ({
  typography: true,
  ...(type ? { [type]: true } : {}),
  defaultFamily: true,
  montserrat: FAMILIES.MONTSERRAT.includes(type),
}));

const tag = as || "span";
</script>

<style lang="scss">
.typography {
  color: #050505;
}

.defaultFamily {
  font-family: "Noto Sans";
  font-weight: 600;
}

.montserrat {
  font-family: "Montserrat";
  font-weight: 500;
}

.HP-Headline-01-d {
  font-size: 96px;
  line-height: 96px;

  @media screen and (max-width: 1430px) {
    font-size: 52px;
    line-height: 52px;
  }
}
.HP-Headline-02-d {
  font-size: 70px;
  line-height: 84px;

  @media screen and (max-width: 1430px) {
    font-size: 36px;
    line-height: 36px;
  }
}
.HP-Headline-03-d {
  font-size: 48px;
  line-height: 62px;

  @media screen and (max-width: 1430px) {
    font-size: 30px;
    line-height: 32px;
  }
}
.HP-Headline-04-d {
  font-size: 40px;
  line-height: 52px;

  @media screen and (max-width: 1430px) {
    font-size: 28px;
    line-height: 34px;
  }
}
.HP-Headline-05-d {
  font-size: 30px;
  line-height: 39px;

  @media screen and (max-width: 1430px) {
    font-size: 26px;
    line-height: 120%;
  }
}
.HP-Subtitle-01-d {
  font-size: 24px;
  line-height: 26.4px;

  @media screen and (max-width: 1430px) {
    font-size: 20px;
    line-height: 24px;
  }
}
.HP-Subtitle-02-d {
  font-size: 20px;
  line-height: 26px;

  @media screen and (max-width: 1430px) {
    font-size: 18px;
    line-height: 24px;
  }
}
.HP-Subtitle-03-d {
  font-size: 18px;
  line-height: 23.4px;

  @media screen and (max-width: 1430px) {
    font-size: 16px;
    line-height: 24px;
  }
}
.HP-Body-01-d {
  font-size: 16px;
  line-height: 24px;

  @media screen and (max-width: 1430px) {
    font-size: 15px;
    line-height: 22.5px;
  }
}
.HP-Body-02-d {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;

  @media screen and (max-width: 1430px) {
    font-size: 15px;
    line-height: 22.5px;
  }
}
.HP-Body-03-d {
  font-size: 14px;
  line-height: 21px;

  @media screen and (max-width: 1430px) {
    font-size: 15px;
    line-height: 22.5px;
  }
}
.HP-Body-04-d {
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;

  @media screen and (max-width: 1430px) {
    font-size: 13px;
    line-height: 19px;
  }
}
.HP-Button-01-d {
  font-size: 18px;
  line-height: 27px;

  @media screen and (max-width: 1430px) {
    font-size: 16px;
    line-height: 24px;
  }
}
.HP-Button-02-d {
  font-size: 14px;
  line-height: 14px;
  @media screen and (max-width: 1430px) {
    font-size: 13px;
  }
}
.HP-Caption-01-d {
  font-size: 12px;
  line-height: 18px;

  @media screen and (max-width: 1430px) {
    font-size: 11px;
    line-height: 16.5px;
  }
}

.HP-Caption-02-d {
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;

  @media screen and (max-width: 1430px) {
    font-size: 11px;
    line-height: 16.5px;
  }
}

.HP-Overline-01-d {
  font-size: 10px;
  line-height: 15px;
  letter-spacing: 0.8px;
  text-transform: uppercase;

  @media screen and (max-width: 1430px) {
    font-size: 9px;
    line-height: 13.5px;
    letter-spacing: 0.72px;
  }
}
.HP-Overline-02-d {
  font-size: 8px;
  font-weight: 600;
  line-height: 12px;
  letter-spacing: 0.64px;
  text-transform: uppercase;

  @media screen and (max-width: 1430px) {
    font-size: 7px;
    line-height: 10.5px;
    letter-spacing: 0.56px;
  }
}
</style>
